import { observer } from "mobx-react"
import { RichContentView } from "@ui"

import type { DocumentSerializerOutput } from "@serializers/documents"

interface FaqDetailsProps {
  data: DocumentSerializerOutput
  id: string
  ordinalNumber: number
}

export const FaqDetails = observer(function FaqDetails(props: FaqDetailsProps) {
  const { data, id, ordinalNumber } = props

  return (
    <>
      <article id={id} className="relative space-y-5 tablet:space-y-6">
        {data.slug && (
          <div
            className="absolute top-[-80px] tablet:top-[-24px]"
            data-faq-id={data.slug}
          />
        )}
        <div className="space-x-3 flex items-start">
          <span className="relative w-8.5 h-8.5 flex flex-shrink-0 border border-black rounded-full">
            <span className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pl-px h-4 text-xl leading-none tracking-normal text-black">
              {ordinalNumber}
            </span>
          </span>
          <h5
            className="self-center uppercase tracking-2 tablet:leading-9"
            dangerouslySetInnerHTML={{ __html: data.title }}
          />
        </div>
        <RichContentView src={data.description} />
      </article>
    </>
  )
})
